export type Direction = "up" | "down" | "left" | "right";

interface ChevronIconProps {
  direction?: Direction;
}

// The base path points DOWN; CSS rotation is clockwise, so pointing right
// needs -90 (and left +90).
const rotationDegrees: Record<Direction, number> = {
  up: 180,
  down: 0,
  left: 90,
  right: -90
};

export function ChevronIcon({ direction = "down" }: ChevronIconProps) {
  const rotate = rotationDegrees[direction];

  return (
    <svg
      data-testid="chevron-icon"
      data-direction={direction}
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      style={{
        transform: `rotate(${rotate}deg)`,
        transition: "transform 0.2s ease"
      }}
      stroke="currentColor"
    >
      <path
        d="M13 5.5L8 10.5L3 5.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
